import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import AdditionalDetails from '../AdditionalDetails';
import ReviewSectionHeader from '../ReviewSectionHeader';

export const mapStateToProps = ({
  retailerSettings: { branding: { brand_call_to_action: ctaColor } = {} } = {},
  language: {
    'returns.step_3.drop_off_details.title': title,
    'returns.step_3.drop_off_details.buttons.edit': editTitle,
  } = {},
  language,
  storeLocator: {
    selectedLocation: {
      addressString,
      additional_details: { in_location_details: items = [] } = {},
    } = {},
  } = {},
}) => ({
  title,
  items: items.map((item) => ({
    ...item,
    label:
      language[`returns.step_3.drop_off_details.labels.${(item.key || '').toLowerCase()}`] ||
      item.key,
    value: item.key === 'Address' && addressString ? addressString : item.value,
  })),
  ctaColor,
  editTitle,
});

const EditButton = styled.a`
  font-size: 12px;
  color: ${(props) => props.ctaColor || '#2B7CAC'};
  font-weight: bold;
`;

const Header = ({ title, editTitle, navigateToStep2, ctaColor }) => (
  <ReviewSectionHeader>
    <span>{title}</span>
    <EditButton href="#" onClick={navigateToStep2} ctaColor={ctaColor}>
      {editTitle}
    </EditButton>
  </ReviewSectionHeader>
);

const DropoffDetails = ({ title, items, toStep2, ctaColor, editTitle }) => {
  const navigateToStep2 = (event) => {
    event.preventDefault();
    toStep2();
  };

  if (items.length === 0) {
    return null;
  }

  return (
    <AdditionalDetails
      {...{
        title: <Header {...{ title, editTitle, navigateToStep2, ctaColor }} />,
        items,
      }}
    />
  );
};

export default connect(mapStateToProps)(DropoffDetails);

Header.defaultProps = {
  title: null,
  editTitle: null,
  navigateToStep2: null,
  ctaColor: '#000000',
};

Header.propTypes = {
  title: PropTypes.string,
  editTitle: PropTypes.string,
  navigateToStep2: PropTypes.func,
  ctaColor: PropTypes.string,
};

DropoffDetails.defaultProps = {
  title: null,
};

DropoffDetails.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};
